import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormServices } from 'src/app/services/form-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { PaymentListComponent } from '../../componentsAdmin/payment-list/product-list.component';

@Component({
  selector: 'app-methods',
  templateUrl: './methods.page.html',
  styleUrls: ['./methods.page.scss'],
})
export class MethodsPage implements OnInit, OnDestroy {
  @ViewChild('paymentList') paymentList: PaymentListComponent;
  public user: any;
  public type = '';
  public title = 'Pedido';
  public orderId = undefined;
  public paymentId = undefined;
  public formMethod: any[] = [];
  public typeUser = 'register';
  private _orderSubscription: Subscription = new Subscription();
  private _domainId = environment.domainId;

  constructor(
    private uiSv: UiServices,
    private route: ActivatedRoute,
    private formSv: FormServices
  ) {}

  async ngOnInit() {
    const form: any = await this.formSv.getForm('orden', this._domainId);
    this.formMethod = form[0]?.select;
    this._orderSubscription = this.route.queryParams.subscribe((params) => {
      this.orderId = params.order;
      if (params.payment) {
        this.orderId = params.payment;
        this.type = 'payment';
        // this.setType({detail: {value: 'payment'}});
      } else {
        this.type = 'order';
      }
    });
  }

  ngOnDestroy(): void {
    this._orderSubscription.unsubscribe();
  }

  getUser(user) {
    this.user = undefined;
    this.user = user;
  }

  setTypeUser(ev) {
    this.typeUser = ev.detail.value;
    setTimeout(() => {
      this.paymentList.setDefault();
    });
  }

  async setType(ev) {
    this.user = undefined;
    await this.uiSv.showLoading();
    setTimeout(async () => {
      this.type === 'order' ? (this.title = 'Pedido') : (this.title = 'Pagos');
      await this.uiSv.loading.dismiss();
    }, 100);
  }
}
